<template>
  <div class="how-it-works">
    <HeaderStyle1>
      <h1 slot="title" v-html="$t('howitworks-head-h1')"></h1>
      <p slot="detail" v-html="$t('howitworks-head-small')"></p>
      <b-img class="header-img" slot="image" src="../assets/imgs/head-img-howitworks.png" alt=""></b-img>
    </HeaderStyle1>

    <main class="main-content">
      <b-container fluid="xl">
        <b-row class="wrapper">
          <b-col class="p-xl-5 p-md-5 p-sm-3 item-wrapper"
                 v-for="(item, index) in list"
                 :key="index"
                 cols="12"
                 xl="6"
                 md="6"
                 sm="12"
          >
            <div class="img-wrapper">
              <b-img :src="item.image" fluid class="item-image"></b-img>
            </div>
            <h5 class="row-title text-center">{{item.title}}</h5>
            <p class="row-detail text-center" v-html="item.detail"></p>
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>

<script>
import HeaderStyle1 from '../components/HeaderStyles1.vue'

export default {
  name: 'HowItWork',
  components: {
    HeaderStyle1
  },
  data () {
    return {
      list: [
        {
          image: require('../assets/imgs/howitworks-img1.png'),
          title: this.$t('howitworks-item-1-title'),
          detail: this.$t('howitworks-item-1-detail')
        },
        {
          image: require('../assets/imgs/howitworks-img2.png'),
          title: this.$t('howitworks-item-2-title'),
          detail: this.$t('howitworks-item-2-detail')
        },
        {
          image: require('../assets/imgs/howitworks-img3.png'),
          title: this.$t('howitworks-item-3-title'),
          detail: this.$t('howitworks-item-3-detail')
        },
        {
          image: require('../assets/imgs/howitworks-img4.png'),
          title: this.$t('howitworks-item-4-title'),
          detail: this.$t('howitworks-item-4-detail')
        }
      ]
    }
  },
  mounted () {
    document.title = 'How it works'
  }
}
</script>
<style lang="scss" scoped>
  .how-it-works {
    .header-img {
      max-width: 55%;
      margin-bottom: 90px
    }
    .main-content {
      margin-top: 80px;
      padding-bottom: 100px;

      .wrapper {
        margin-top: 60px;
      }

      .row-title {
        font-size: 35px;
        font-weight: 700;
        color: #000000;
        margin-top: 30px;
      }

      .row-detail {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 20px;
        opacity: 0.8;
      }

      .img-wrapper {
        position: relative;
        height: 360px;
        display: inline-flex;
        align-items: center;

        .item-image{
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .header-img {
      max-width: 55%;
      margin-bottom: 10px !important;
    }

    .main-content {
      margin-top: 20px !important;
    }
    .wrapper {
      margin-top: 20px !important;

      .item-wrapper {
        padding: 0 50px!important;

        .img-wrapper {
          height: auto;
          margin-top: 40px;
        }

        .row-title {
          font-size: 18px;
        }
        .row-detail {
          font-size: 14px;
        }
      }
    }
  }
</style>
